function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "unavailable",
  transform: "translate(-4.5 -4.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11656",
  "data-name": "Path 11656",
  d: "M48.208,12A25.6,25.6,0,1,1,12,12a25.6,25.6,0,0,1,36.209,0ZM42.029,46.051,14.152,18.178A19.918,19.918,0,0,0,42.031,46.057Zm2.156-30.03a19.919,19.919,0,0,1,1.87,26.007L18.176,14.153a19.918,19.918,0,0,1,26.011,1.87Z",
  transform: "translate(0 0)",
  fill: "#ac1ede",
  fillRule: "evenodd"
}));

var SvgUnavailable = function SvgUnavailable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51.207,
    height: 51.207,
    viewBox: "0 0 51.207 51.207",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnavailable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unavailable.2cbb1ee1.svg";
export { ForwardRef as ReactComponent };